import React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { ProjectWorkOrderType } from 'types/project.type'
import { dateFormat, datePickerFormat, isDateWithinRange } from 'utils/date-time-utils'
import Status from 'features/common/status'
import numeral from 'numeral'

export const WORK_ORDER_TABLE_QUERY_KEYS = {
  statusLabel: 'statusLabel.equals',
  skillName: 'skillName.contains',
  companyName: 'companyName.contains',
  businessEmailAddress: 'businessEmailAddress.contains',
  businessPhoneNumber: 'businessPhoneNumber.contains',
  workOrderIssueDate: 'workOrderIssueDate.equals',
  workOrderExpectedCompletionDate: 'workOrderExpectedCompletionDate.equals',
}

export const WORK_ORDER_TABLE_COLUMNS: ColumnDef<ProjectWorkOrderType>[] = [
  {
    header: 'id',
    accessorKey: 'id',
    size: 90,
    accessorFn: cellInfo => {
      return cellInfo.id ? cellInfo.id?.toString() : '- - -'
    },
  },

  {
    header: 'WOstatus',
    accessorKey: 'statusLabel',
    size: 145,
    cell: row => {
      let value = row.cell.getValue() as string

      return <Status value={value} id={value} />
    },
  },
  {
    header: 'trade',
    accessorKey: 'skillName',
    size: 130,
  },
  {
    header: 'name',
    accessorKey: 'companyName',
    size: 130,
  },
  {
    header: 'email',
    accessorKey: 'businessEmailAddress',
  },
  {
    header: 'phone',
    accessorKey: 'businessPhoneNumber',
    size: 130,
  },
  {
    header: 'finalInvoice',
    accessorKey: 'finalInvoiceAmount',
    size: 130,
    accessorFn(cellInfo: any) {
      return cellInfo.finalInvoiceAmount?.toString()
    },
    filterFn: 'includesString',
    cell: (row: any) => {
      const value = row.cell.getValue() as string

      return numeral(value).format('$0,0.00')
    },
  },
  {
    header: 'issue',
    accessorKey: 'workOrderIssueDate',
    accessorFn: row => datePickerFormat(row.workOrderIssueDate),
    cell: (row: any) => {
      const value = row?.row.original?.workOrderIssueDate
      return dateFormat(value)
    },
    meta: { format: 'date' },
    filterFn: (row: any, _columnId: string, filterValue: string) => {
      if (row.original.workOrderIssueDate) {
        return isDateWithinRange(row.original.workOrderIssueDate, filterValue)
      }
      return false
    },
  },
  {
    header: 'expectedCompletion',
    accessorKey: 'workOrderExpectedCompletionDate',
    size: 200,
    accessorFn: row => datePickerFormat(row.workOrderExpectedCompletionDate),
    cell: (row: any) => {
      const value = row?.row.original?.workOrderExpectedCompletionDate
      return dateFormat(value)
    },
    meta: { format: 'date' },
    filterFn: (row: any, _columnId: string, filterValue: string) => {
      if (row.original.workOrderExpectedCompletionDate) {
        return isDateWithinRange(row.original.workOrderExpectedCompletionDate, filterValue)
      }
      return false
    },
  },
]
